<br *ngIf="client" />

<div *ngIf="soldRented != null" class="bottom-space">
  <yes-no
    [yesValue]="'Aanbrengen door Inpress'"
    [noValue]="
      EX_EDIT_ADJUSTMENT_KEY.STICKER_APPLIED_BY_CUSTOMER
        | exEditAdjustmentString : !showClientStrings
    "
    [nullIsFalse]="false"
    [neverShowExtraInstructions]="true"
    [value]="soldRented.installByInpress"
    [disabled]="client && subproject.id != null"
    (answer)="installByInpressChange($event)"
  ></yes-no>

  <ng-container *ngIf="!!ipBoard; else stickerOptions">
    <sold-rented-sticker-select
      [ipBoard]="ipBoard"
      [ipBoardPart]="ipBoard.boardPart"
      [soldRented]="soldRented"
      (save)="soldRentedStickerChange($event)"
    >
    </sold-rented-sticker-select>
  </ng-container>

  <ng-template #stickerOptions>
    <div class="sold-rented__row">
      <div class="title">Kies hier de gewenste sticker</div>

      <div>
        <mat-form-field appearance="outline">
          <mat-select
            matInput
            placeholder="Maak een keuze"
            [(ngModel)]="selectedSticker"
            [compareWith]="compareOptions"
            (selectionChange)="soldRentedStickerChange($event)"
          >
            <mat-option *ngFor="let option of STICKER_OPTIONS" [value]="option">
              {{ option.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          (change)="setOtherStickerValue($event)"
          *ngIf="selectedSticker?.id === OTHER_STICKER_ID"
          style="margin-left: 1em"
        >
          <input
            matInput
            placeholder="Gewenste sticker"
            [(ngModel)]="otherStickerValue"
          />
        </mat-form-field>
      </div>
    </div>
  </ng-template>
</div>

<div *ngIf="repo != null" class="bottom-space">
  <yes-no
    [yesValue]="'Weghalen door Inpress'"
    [noValue]="'Project is al weggehaald'"
    [nullIsFalse]="false"
    [neverShowExtraInstructions]="true"
    [value]="repo.repoByInpress"
    [disabled]="client && subproject.id != null"
    (answer)="repoByInpressChange($event)"
  ></yes-no>

  <yes-no
    *ngIf="showStoreQuestion"
    [yesValue]="'Stockeren'"
    [noValue]="'Weggooien'"
    [nullIsFalse]="false"
    [nullable]="true"
    [neverShowExtraInstructions]="true"
    [value]="repo.store"
    [disabled]="client && subproject.id != null"
    (answer)="storeChange($event)"
  ></yes-no>
</div>

<span *ngIf="baseProjectTitle?.length > 0" class="italics-text">
  Gekozen in basisproject: {{ baseProjectTitle }}
</span>

<textarea-input
  [title]="extraInfoAdjustmentTitle"
  [minHeight]="200"
  [placeholder]="
    EX_EDIT_ADJUSTMENT_KEY.EXTRA_INFO_ADJUSTMENT_PLACEHOLDER
      | exEditAdjustmentString : !showClientStrings : subproject
  "
  [initContent]="this.subproject.extraInfoAdjustment"
  [disabled]="(client && subproject.id != null) || disableAllInputs"
  [client]="client"
  (answer)="setAdjustmentExtraInfo($event)"
></textarea-input>

<div *ngIf="soldRented != null" class="bottom-space">
  <checkbox
    [text]="
      EX_EDIT_ADJUSTMENT_KEY.USE_STANDARD_LAYOUT
        | exEditAdjustmentString : !showClientStrings
    "
    [checked]="soldRented.useStandardLayout"
    [isDisabled]="(client && subproject.id != null) || disableAllInputs"
    (answer)="useStandardLayoutChange($event)"
  ></checkbox>
</div>

<div *ngIf="multipleCompaniesInvolved">
  <yes-no
    [title]="'Kosten delen'"
    [yesValue]="
      EX_EDIT_ADJUSTMENT_KEY.ASSUME_ALL_COSTS_YES
        | exEditAdjustmentString : !showClientStrings : subproject
    "
    [noValue]="
      EX_EDIT_ADJUSTMENT_KEY.ASSUME_ALL_COSTS_NO
        | exEditAdjustmentString : !showClientStrings : subproject
    "
    [nullIsFalse]="false"
    [neverShowExtraInstructions]="true"
    [value]="subproject.splitCosts"
    [disabled]="(client && subproject.id != null) || disableAllInputs"
    [client]="client"
    (answer)="splitCostsChange($event)"
  ></yes-no>
</div>

<file-picker
  *ngIf="subproject.type !== 'Repo'"
  [hideUpload]="false"
  [title]="
    'Upload hier afbeeldingen van ' +
    getFormDisplayArticle() +
    ' ' +
    getFormDisplayNameLowerCase()
  "
  [inputProjectPlacement]="subproject.projectPlacement"
  [formSection]="'adjustmentExternal'"
  [client]="client"
  [disabled]="(client && subproject.id != null) || disableAllInputs"
></file-picker>

<div *ngIf="baseProjectPlacement?.appointment">
  <p class="italics-text">
    Er was een afspraak nodig voor deze plaatsing, moet er opnieuw een afspraak
    gemaakt worden?
  </p>
</div>

<ng-container *ngIf="projectHasIPBoard; else regularAppointment">
  <ip-board-appointment
    [project]="project"
    [projectPlacement]="subproject.projectPlacement"
    (save)="save()"
  ></ip-board-appointment>
</ng-container>
<ng-template #regularAppointment>
  <yes-no
    [title]="'Afspraak nodig'"
    [showExtraInstructionsOn]="'Ja'"
    [extraInstructions]="'Naam en GSM-nr contactpersoon + uur'"
    [value]="subproject.projectPlacement.appointment"
    [inputText]="subproject.projectPlacement.needAppointmentInfo"
    [nullIsFalse]="true"
    [nullable]="false"
    [disabled]="disabled"
    [client]="client"
    (answer)="appointmentChange($event)"
    (answeredText)="needAppointmentInfoChange($event)"
  ></yes-no>
</ng-template>

<div
  class="d-flex"
  [ngClass]="subproject.projectPlacement.collectKey ? '' : 'under-space'"
>
  <yes-no
    [title]="'Sleutel afhalen'"
    [neverShowExtraInstructions]="true"
    [nullable]="false"
    [nullIsFalse]="true"
    [value]="subproject.projectPlacement.collectKey"
    [disabled]="disabled"
    [client]="client"
    (answer)="collectKeyChange($event)"
  ></yes-no>
  <div
    *ngIf="subproject.projectPlacement.collectKey"
    class="left-fifteen-space align-collect-key-from collect-key-from-width"
  >
    <collect-key-from-selector
      [projectPlacement]="subproject.projectPlacement"
      [project]="project"
      (collectKeyFromChanged)="output.emit()"
    ></collect-key-from-selector>
  </div>
</div>
<div
  *ngIf="subproject.projectPlacement.collectKeyFrom === -1"
  class="align-collect-key-extra-info-with-selector"
>
  <textarea-input
    [placeholder]="'Adres noteren + openingsuren'"
    [initContent]="subproject.projectPlacement.collectKeyExtraInfo"
    (answer)="collectKeyExtraInfoChange($event)"
  ></textarea-input>
</div>

<div class="d-flex">
  <checkbox
    [title]="
      EX_EDIT_ADJUSTMENT_KEY.REQUESTED_PLACEMENT_DATE
        | exEditAdjustmentString : !showClientStrings : subproject
    "
    [text]="getASAPCheckboxText()"
    [checked]="subproject.projectPlacement.placeASAP"
    [isDisabled]="(client && subproject.id != null) || disableAllInputs"
    (answer)="placeASAP($event)"
  ></checkbox>
  <div class="next-to-checkbox"><b>OF</b></div>
  <mat-form-field class="next-to-checkbox-last" appearance="outline">
    <input
      matInput
      [matDatepickerFilter]="daysFilter"
      [matDatepicker]="placementPicker"
      placeholder="Selecteer een datum"
      [(ngModel)]="subproject.projectPlacement.placementEarliestDate"
      [disabled]="(client && subproject.id != null) || disableAllInputs"
      (ngModelChange)="placementEarliestDateChange($event)"
    />
    <mat-error *ngIf="dateError">
      Datum mag niet sneller dan 3 werkdagen zijn!
    </mat-error>
    <mat-datepicker-toggle
      matSuffix
      [for]="placementPicker"
    ></mat-datepicker-toggle>
    <mat-datepicker #placementPicker></mat-datepicker>
  </mat-form-field>
</div>
